import { signInWithRedirect } from 'aws-amplify/auth'

export function startOauthFlow(identity_provider = 'Google') {
  return signInWithRedirect({ provider: identity_provider })
}
